import { useStore } from '../lib/store';

/** Reactive logout flag the auth hook writes from /auth/me. */
export function useExplicitLogout(): boolean {
  return useStore((state) => state.explicitLogout);
}
